import React from 'react';
import useCurrentEmployee from '../hooks/useCurrentEmployee';

export default function ContractAccess() {
  const { currentEmployee, loading } = useCurrentEmployee();
  if (loading) return <div className="p-6">Loading your access...</div>;
  return <div className="mx-auto max-w-xl p-6 font-Nunito">
    <h1 className="text-2xl font-bold text-slate-900">Contract access</h1>
    <p className="mt-3 text-slate-600">Your contract is active, but no workspace tabs are assigned yet. Your administrator or department head can assign a project or grant access.</p>
    {currentEmployee?.department?.name && <p className="mt-4 text-sm text-slate-500">Department: {currentEmployee.department.name}</p>}
  </div>;
}
